
<app-loader *ngIf="loading"></app-loader>
<div class="timezone">
  <div class="header">
    <div class="title">
      {{"PAGES.MANAGEMENT.TIMEZONE_DIALOG.TITLE" | translate}}
      <span (click)="closeDialog()" class="material-icons side-nav-bar-close">clear</span>
    </div>
  </div>
  <div class="body">

    <mat-select [(ngModel)]="timeZone"[placeholder]="'PAGES.FILTER.PLACEHOLDERS.SEARCH_COUNTRY' | translate" (selectionChange)="onChange($event)">
      <mat-option *ngFor="let timeZone of timeZones" [value]="timeZone.id">
        <p class="text-value"> {{timeZone.displayName}} </p>
      </mat-option>
    </mat-select>
  </div>
  <div class="footer">
    <button (click)="updateTimezone()" [disabled]="timeZone === ''">
      {{('PAGES.MANAGEMENT.TIMEZONE_DIALOG.BUTTON' | translate) | uppercase }}
    </button>
  </div>
</div>
